export enum ComponentType {
  // Assets
  SubmersiblePump = 'SUBMERSIBLE_PUMP',
  Pump = 'PUMP',
  SpinningPump = 'SPINNING_PUMP',
  Well = 'WELL',
  Tower = 'TOWER',
  Valve = 'VALVE',

  // General
  TextLabel = 'TEXT_LABEL',
  LiveTagLabel = 'LIVE_TAG_LABEL',
  ImageUpload = 'IMAGE_UPLOAD',
  WaterLevelShape = 'WATER_LEVEL_SHAPE',
  Rotor = 'ROTOR',

  // Shapes
  Rectangle = 'RECTANGLE',
}
